import axios from "axios";

class RemoteData {
  constructor(url) {
    // Configurations ...
    this.url = url;
    this.takeAtLeast = null;
    this.withParams = {};

    // Default states ...
    this.data = null;
    this.loading = false;
    this.response = null;
  }

  load(callback = null) {
    this.beforeLoad();

    this.request()
      .then(response => {
        this.onLoadSuccess(response);
        this.afterLoad();
        if (callback) {
          callback(this);
        }
      })
      .catch(error => {
        this.onLoadFail(error);
        this.afterLoad();
      });

    return this;
  }

  request() {
    return axios
      .get(this.resolveUrl(), { params: this.requestParams() })
      .takeAtLeast(this.takeAtLeastValue);
  }

  requestParams() {
    return this.resolveParams(this.withParams);
  }

  takeAtLeastTime(duration) {
    this.takeAtLeastValue = duration;
    return this;
  }

  resolveUrl() {
    return typeof this.url === "function" ? this.url() : this.url;
  }

  resolveParams(params) {
    return params;
  }

  beforeLoad() {
    this.loading = true;
  }

  with(withParams, clear = false) {
    this.withParams = Object.assign(clear ? {} : this.withParams, withParams);
    return this;
  }

  onLoadSuccess(response) {
    this.response = response;
    this.whenLoaded(this.response.data);
    this.loading = false;
  }

  onLoadFail() {
    this.loading = false;
  }

  whenLoaded(data) {
    this.setData(data.data);

    return this;
  }

  setData(data) {
    this.data = data;
    return this;
  }

  afterLoad() {
    this.loading = false;
  }
}

export default RemoteData;
